import React from 'react';
import { componentService } from 'js/services/component.service';

import style from './index.scss';

export const Tooltip = ({ children }) => {
    return (
        <div className={style.tooltip}>
            <span className={style.action}></span>
            <div className={style.balloon}>
                <div className={style.icon}></div>
                <div className={style.content}>{children}</div>
            </div>
        </div>
    );
};

componentService.registerWebContentComponents({ Tooltip });
